<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-preface" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-preface" id="toc-ad-card"><a href="#/adcard">Also by R.J. Ellory</a></p>
<p class="toc-chapter" id="toc-chapter000"><a href="#/chapter000">Chapter 1</a></p>
<p class="toc-chapter" id="toc-chapter001"><span href="#/chapter001" title="Link target outside of Sample">Prologue</span></p>
<p class="toc-preface" id="toc-preface002"><span href="#/preface002" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ae470338